/**
 * CRA: REACT_APP_* 만 빌드 시 주입됩니다.
 * REACT_APP_API_URL: Node API 베이스만. Python 등은 서버가 PY_API_URL 로 호출하므로 클라이언트 env 불필요.
 */
const raw = process.env.REACT_APP_API_URL;
const trimmed =
    raw != null && String(raw).trim() !== '' ? String(raw).trim().replace(/\/+$/, '') : '';

export const PUBLIC_API_BASE_URL = trimmed || 'http://localhost:3001';

if (process.env.NODE_ENV === 'development' && !trimmed) {
    // eslint-disable-next-line no-console
    console.warn('[env] REACT_APP_API_URL 미설정 — 기본값 사용:', PUBLIC_API_BASE_URL);
}
